import PropTypes from "prop-types";
import React, { Component } from "react";
import { Grid, Box, CircularProgress } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import moment from "moment";
import HeaderInfo from "../../waybee-ui/HeaderInfo/HeaderInfo";
import Group from "../../waybee-ui/Group";
import Divider from "../../waybee-ui/Divider";
import CollapseGroup from "../../waybee-ui/CollapseGroup";
import StudentService from "../../services/StudentService";
import DisciplineListItem from "./components/DisciplineListItem";
import BackButton from "../../components/BackButton";

const HeaderGrid = styled(Grid)`
  margin-bottom: -20px;
`;

const HeaderGroup = styled(Group)`
  padding-bottom: 0;
`;

const GeralAverage = styled.div`
  margin-bottom: 8px;
`;

class StudentStatistics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      student: null,
      reportCards: []
    };
  }

  async componentDidMount() {
    const { match } = this.props;
    const { studentId } = match.params;
    const student = await StudentService.getStudentById(studentId);
    await this.getStudentGrades(studentId);
    this.setState({ student });
  }

  getStudentGrades = async studentId => {
    const grades = await StudentService.getGrades(studentId);
    const reportCards = grades.reportCards.map(grade => ({
      id: grade.id,
      name: grade.course.name,
      period: grade.course.coursePeriodDescription,
      lastUpdate: moment(grade.updatedAt).format("DD/MM/YYYY [às] HH:mm"),
      disciplines: grade.academicPeriods.map(discipline => discipline)
    }));

    this.setState({ reportCards });
  };

  render() {
    const { student, reportCards } = this.state;
    if (!student || !reportCards) {
      return (
        <Box p={6} textAlign="center">
          <CircularProgress />
        </Box>
      );
    }

    return (
      <Grid container spacing={2}>
        <BackButton to={`/student/${student.id}`} />
        <HeaderGrid item xs={12}>
          <HeaderGroup>
            <Box mb={2}>
              <HeaderInfo
                name={student.name}
                info={`R.A: ${student.ra}`}
                photo={student.photo}
              />
            </Box>
            <Divider />
          </HeaderGroup>
        </HeaderGrid>
        {reportCards.map(periods => (
          <Grid item xs={12} key={periods.id}>
            {periods.disciplines.map(period => (
              <CollapseGroup title={period.name}>
                <GeralAverage>
                  <DisciplineListItem
                    color={period.data.geralAverageData.color}
                    discipline="Média Geral"
                    admissionStatus={period.data.admissionStatusData}
                    average={period.data.geralAverageData.average}
                  />
                </GeralAverage>
                {period.data.disciplines.map(discipline => (
                  <DisciplineListItem
                    key={discipline.id}
                    discipline={discipline.name}
                    color={discipline.color}
                    teacher={discipline.teacher}
                    average={{
                      value: discipline.mainAverages[0].value,
                      color: discipline.mainAverages[0].color
                    }}
                    description={discipline.mainAverages[0].description}
                    evaluations={discipline.evaluations}
                  />
                ))}
              </CollapseGroup>
            ))}
          </Grid>
        ))}
      </Grid>
    );
  }
}

StudentStatistics.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.array
  }).isRequired
};
export default withRouter(StudentStatistics);
